(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    async function submitEmailSignupForm(form) {
    const blockId = form.querySelector('[name="contact[id]"]')?.value?.replace('EmailSignup-', '');
    const button = form.querySelector('.email-signup__button');
    if (button) button.disabled = true;

    try {
      const response = await fetch(form.action || '/contact', {
        method: 'POST',
        body: new FormData(form),
        redirect: 'manual',
      });

      const isSuccess = response.ok || response.type === 'opaqueredirect' || response.status === 0;

      if (isSuccess) {
        const successEl = form.querySelector(`#Email-signup__message-success-${blockId}`);
        form.querySelector('.email-signup__input-group').style.display = 'none';

        if (successEl) {
          successEl.style.display = 'flex';
          successEl.focus();
        } else {
          const msg = document.createElement('div');
          msg.className = 'email-signup__message';
          msg.textContent = 'Thank you for subscribing!';
          form.appendChild(msg);
        }
      } else {
        const errorEl = form.querySelector(`#Email-signup__message-error-${blockId}`);
        if (errorEl) errorEl.style.display = 'flex';
        if (button) button.disabled = false;
      }
    } catch {
      if (button) button.disabled = false;
    }
  }

  function patchEmailSignupForm(form) {
    // Перехватывает form.submit() — вызывается Shopify Captcha после верификации
    form.submit = function () {
      submitEmailSignupForm(form);
    };

    // На случай если капча не установлена
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submitEmailSignupForm(form);
    });
  }

  document.querySelectorAll('.email-signup__form').forEach(patchEmailSignupForm);
  } catch(e) { console.error(e); }
})();

})();
